import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CustomerService } from '../_services';
import * as CustomerActions from '../_actions/customer';

@Injectable({
  providedIn: 'root',
})
export class CustomerEffects {
  loadCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.loadCustomers),
      mergeMap(() =>
        this.customerService.getCustomers().pipe(
          map((customers) => CustomerActions.loadCustomersSuccess({ customers })),
          catchError((error) => of(CustomerActions.loadCustomersFailure({ error })))
        )
      )
    )
  );

  addCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.addCustomer),
      mergeMap(({ customer }) =>
        this.customerService.saveCustomer(customer).pipe(
          map((savedCustomer) => CustomerActions.addCustomerSuccess({ customer: savedCustomer })),
          catchError((error) => of(CustomerActions.addCustomerFailure({ error })))
        )
      )
    )
  );

  updateCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.updateCustomer),
      mergeMap(({ customer }) =>
        this.customerService.saveCustomer(customer).pipe(
          map((updatedCustomer) =>
            CustomerActions.updateCustomerSuccess({ customer: updatedCustomer })
          ),
          catchError((error) => of(CustomerActions.updateCustomerFailure({ error })))
        )
      )
    )
  );

  deleteCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.deleteCustomer),
      mergeMap(({ id }) =>
        this.customerService.deleteCustomer(id).pipe(
          map(() => CustomerActions.deleteCustomerSuccess({ id })),
          catchError((error) => of(CustomerActions.deleteCustomerFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private customerService: CustomerService
  ) {}
}
